import type { api } from '~/modules';

/** Gets the query/mutation name */
export function getGQLDocumentOperationName(gqlDocument: api.GraphQLDocument<any, any>) {
    const def = gqlDocument.definitions.find(x => x.kind === 'OperationDefinition');

    if (def && 'name' in def && def.name?.kind === 'Name') {
        return def.name.value;
    }

    return null;
}
